import React from 'react'
import styled, { css } from 'styled-components'

export const StyledComponent = styled(
  (
    {
      is_admin,
      ...rest
    }) => <header {...rest} />
)`
  height: 100%;
  width: 100%;
  background-color: ${p => p.theme.cWhite};
  ${p => p.is_admin && css`
    background-color: #cfeaf3;
  `}

  .stripes > hr {
    height: 1px;
    margin: 0 0 1px 0;

    @media (min-width: ${p => p.theme.mobileLargeSize}) {
      height: 5px;
      margin: 0 0 2px 0;
    }
  }
`
const _PageHeader_Styled = (props) => <StyledComponent {...props} />
_PageHeader_Styled.propTypes = {}
_PageHeader_Styled.className = StyledComponent

export default _PageHeader_Styled
